import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import store from './store/vuex'
import router from './router'
import PortalVue from 'portal-vue'
import MobileDetect from './plugins/mobile-detect'
import './plugins/mixpanel'
import './plugins/moment'
import i18n from './i18n'
import api from './api/index'
import server from './api/server'
import { includes } from './api/utils'
import App from './App.vue'
import timer from './api/timer'
import './plugins/element-ui'
import './plugins/floating-vue'
import './plugins/okta-vue'
import './directives/horizontal-drag-scrolling'

sync(store, router)

Vue.use(PortalVue)
Vue.use(MobileDetect)

if (includes(server.prodServers, api.env)) {
  Vue.config.productionTip = false
  Vue.config.debug = false
  Vue.config.devtools = false
  Vue.config.silent = true
} else {
  Vue.config.debug = true
  Vue.config.devtools = true
  Vue.config.silent = false

  /**
   * Fixes page crashing when vue-devtool opened
   *
   * Original error stack:
   * SyntaxError: Unexpected token o in JSON at position 1
   *  at parse (<anonymous>)
   *  at JSON.parse (VM42 624:53)
   *  at eval (eval at I.c.loading (eval at embedpano (VM22 krpano.min.js:10)), <anonymous>:50:25)
   */
  const _jsonParse = JSON.parse
  JSON.parse = function () {
    try {
      return _jsonParse(...arguments)
    } catch (e) {
      // prevent krpano keeps receiving message from vuex and throwing error
      if (e.stack.includes('embedpano') && e.stack.includes('krpano.min.js')) {
        return {}
      }
      console.error(e)
    }
  }
}

Vue.prototype.$isChina = false
timer.chinaTimer()
  .then(() => {
    Vue.prototype.$isChina = false
  })
  .catch(() => {
    Vue.prototype.$isChina = true
  })
  .finally(() => {
    const app = new Vue({
      el: '#app',
      store,
      router,
      i18n,
      render: h => h(App)
    })

    store.$vm = app
    app.$mount('#app')
  })
